export const SESSION_REFRESH_SUCCESS = 'SESSION_REFRESH_SUCCESS'
export const SESSION_REFRESH_FAILURE = 'SESSION_REFRESH_FAILURE'
export const LOGOUT = 'USER_LOGOUT'